import { render } from "./connectedapps.vue?vue&type=template&id=090b8db4"
import script from "./connectedapps.vue?vue&type=script&lang=js"
export * from "./connectedapps.vue?vue&type=script&lang=js"

import "./connectedapps.vue?vue&type=style&index=0&id=090b8db4&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__